/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid } from '@mui/material'
import { FormikProps } from 'formik'
import {
  Button,
  DropdownField,
  NumberField,
  TextField,
} from 'shared/components'
import { SelectOption } from 'shared/components/SelectField'
import { GiftConditionCreateModel } from 'types/gift-conditions'

interface ICreateFormProps {
  formik: FormikProps<GiftConditionCreateModel>
  onBack: () => void
  isSubmiting?: boolean
  productOptions: Array<SelectOption<string>>
}

const CreateForm = ({
  formik,
  productOptions = [],
  onBack,
  isSubmiting = false,
}: ICreateFormProps) => {
  const {
    handleBlur,
    handleChange,
    touched,
    errors,
    submitForm,
    setFieldValue,
  } = formik || {}

  const onProductCodeChange = (_e: any, value: SelectOption<string | null>) => {
    setFieldValue('productCode', value?.value || '')
    setFieldValue(
      'productName',
      (productOptions.find(x => x.value === value?.value)?.label as string) ||
        ''
    )
  }

  return (
    <Grid spacing={2} container>
      <Grid item xs={12}>
        <DropdownField
          id="pr"
          name="productCode"
          label="Sản phẩm"
          onChange={onProductCodeChange}
          onBlur={handleBlur}
          error={!!errors.productCode && touched.productCode}
          helperText={
            !!errors.productCode && touched.productCode
              ? errors.productCode
              : ''
          }
          options={productOptions}
        />
      </Grid>
      <Grid item xs={12}>
        <NumberField
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.temQuantity && touched.temQuantity}
          helperText={
            !!errors.temQuantity && touched.temQuantity
              ? errors.temQuantity
              : ''
          }
          id="temQuantity"
          name="temQuantity"
          fullWidth
          label="Số lượng tem"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.createdUser && touched.createdUser}
          helperText={
            !!errors.createdUser && touched.createdUser
              ? errors.createdUser
              : ''
          }
          id="createdUser"
          name="createdUser"
          label="Người tạo"
        />
      </Grid>
      <Grid container gap={2} mt={2} ml={2}>
        <Button
          disabled={isSubmiting}
          width={100}
          color="inherit"
          onClick={onBack}
        >
          Quay về
        </Button>
        <Button loading={isSubmiting} width={120} onClick={submitForm}>
          Xác nhận
        </Button>
      </Grid>
    </Grid>
  )
}

export default CreateForm
